import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
} from '@chakra-ui/react';
import { ChevronDown } from '@kula-ai/icons/outline/ChevronDown';
import { NodeViewWrapper } from '@tiptap/react';
import { useState } from 'react';
import './surveyEditor.scss';
import { KText } from '@/ui-library/components/text';
import { useSurveyList } from '@/hooks/useSurvey';

// This component will be rendered inline in the editor
export const SurveySelectComponent = ({
  node,
  updateAttributes,
  deleteNode, // eslint-disable-line
  extension,
}) => {
  const { data: surveyOptions } = useSurveyList();

  const { surveyId } = node.attrs;
  const selectedSurvey = JSON.parse(
    localStorage.getItem('editorSelectedSurvey')
  );
  const [searchValue, setSearchValue] = useState('');
  const handleSelect = (value) => {
    const el = document.querySelector('.editor-survey-select-container');
    if (el) {
      el.classList.remove('empty-survey-placeholder-error');
    }
    updateAttributes({ surveyId: value });

    // Get the selected item details
    const selectedItem =
      surveyOptions?.find((opt) => opt.value === value) || null;

    // Call the callback if provided
    if (extension?.options?.onSurveySelect && selectedItem) {
      extension.options.onSurveySelect(selectedItem);
    }

    setSearchValue(''); // Reset search after selection
  };

  const handleMenuClose = () => {
    setSearchValue(''); // Reset search when menu closes
  };

  // Filter options based on search value
  const filteredOptions =
    surveyOptions?.filter((option) =>
      option.label.toLowerCase().includes(searchValue.toLowerCase())
    ) || [];

  const currentValue =
    surveyOptions?.find((opt) => opt.value === surveyId) || null;

  return (
    <NodeViewWrapper
      as="span"
      contentEditable={false}
      style={{ display: 'inline-block' }}
    >
      <Box
        className="editor-survey-select-container"
        display="inline-block"
        data-test-id="survey-select-inline"
        onClick={(e) => e.stopPropagation()}
      >
        <Menu isLazy placement="auto" onClose={handleMenuClose}>
          <MenuButton
            as={Button}
            rightIcon={
              <Icon
                className="editor-survey-select-color"
                as={ChevronDown}
                width="18px"
                height="18px"
                color="var(--kula-colors-primary-600, #605AFB)"
                ml="-5px"
              />
            }
            size="sm"
            bg="#DEE4FF"
            className="editor-survey-select-color editor-survey-select-bg-color"
            color="var(--kula-colors-primary-600, #605AFB)"
            fontWeight="550"
            fontSize="14px"
            width="100%"
            textAlign="left"
            _hover={{ bg: '#D0D9FF' }}
            _active={{ bg: '#C2CCFF' }}
            height="auto !important"
            p="5px !important"
          >
            {currentValue?.label || selectedSurvey?.label || 'Select a survey'}
          </MenuButton>
          <MenuList
            zIndex="5"
            minWidth="250px"
            maxH="300px"
            overflowY="auto"
            borderColor="border-color"
            borderWidth="1px"
            borderRadius="8px"
            boxShadow="0px 4px 12px rgba(0, 0, 0, 0.08)"
            p="0"
            m="0"
          >
            {filteredOptions?.length > 0 ? (
              filteredOptions?.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => handleSelect(option.value, option.label)}
                  bg="white"
                  _hover={{ bg: '#F8F9FC' }}
                  _focus={{ bg: '#F8F9FC' }}
                  py="10px"
                  px="12px"
                  borderBottom="1px solid"
                  borderColor="border-color"
                  borderRadius="0"
                  _last={{ borderBottom: 'none' }}
                >
                  <KText size="sm-regular" color="secondary-700 !important">
                    {option.label}
                  </KText>
                </MenuItem>
              ))
            ) : (
              <Box px="3" py="2" color="gray.500" fontSize="sm">
                No surveys found
              </Box>
            )}
          </MenuList>
        </Menu>
      </Box>
    </NodeViewWrapper>
  );
};
